import { Flex } from '@components';
import styled from 'styled-components';
import { TabletAndUp } from 'src/components/stylingUtils';

export default {
  Nav: styled.nav`
    height: 40px;
    background-color: ${props => props.theme.colors.mutedBlue[500]};
    margin: 0 auto;
    display: flex;
    justify-content: center;
  `,
  Container: styled(Flex)`
    padding: 0;
    max-width: 1920px;
    width: 100%;

    ${props => TabletAndUp(props)} {
      padding: 0 ${props => props.theme.spacing.md};
    }
  `
};
